import React from 'react';
import Chart from 'react-apexcharts';

import { percentageFormatter } from 'buyside/util/formatNumber';

import styles from './viewsChartStyles.scss';

const ViewsChart: React.FC<{ pairs: [string, number][] }> = ({ pairs }) => {
  const { series, labels } = pairs.reduce(
    (result: { labels: string[]; series: number[] }, pair) => {
      result.labels.push(pair[0]);
      result.series.push(pair[1]);

      return result;
    },
    { series: [], labels: [] }
  );

  return (
    <div className={styles.viewsChart}>
      <Chart
        height="100%"
        series={series}
        type="pie"
        options={{
          chart: {
            fontFamily: 'Lato',
            type: 'pie'
          },
          colors: ['#5D84B0', '#3A71B0', '#4A90E2', '#87BFFF', '#173C66'],
          dataLabels: {
            formatter: percentageFormatter
          },
          labels,
          legend: {
            show: false
          },
          tooltip: {
            y: {
              formatter: percentageFormatter
            }
          }
        }}
      />
    </div>
  );
};

export default ViewsChart;
